import { useCallback, useRef } from 'react';
import { ChangedOptionInfo } from 'devextreme/events';
import { DataGrid } from 'devextreme-react/data-grid';
import { dxDataGridColumn } from 'devextreme/ui/data_grid';
import { SortType } from '@/Components/DataTable/types';

export const useOnFilterChanged = <TData>(
  innerGridRef: React.MutableRefObject<DataGrid<TData, keyof TData> | undefined>,
  sortHighlightExcludeKey?: { key: keyof TData; sortType: SortType },
) => {
  const fullNames = useRef<string[]>([]);

  const changeHightlight = (fullNames: string[]) => {
    const dataGridHeader: HTMLElement | null = document.querySelector('.dx-datagrid-headers');

    if (!dataGridHeader) return;

    if (fullNames.length === 0) {
      dataGridHeader.style.backgroundColor = 'transparent';
      return;
    }

    if (!sortHighlightExcludeKey) {
      dataGridHeader.style.backgroundColor = '#fff0cc';
      return;
    }

    const { key, sortType } = sortHighlightExcludeKey;
    const columns = innerGridRef?.current?.instance.state()?.columns;
    const sortedColumn = columns.find((item: dxDataGridColumn) => item.name == key);

    if (sortedColumn.sortOrder == sortType) {
      dataGridHeader.style.backgroundColor = 'transparent';
    } else {
      dataGridHeader.style.backgroundColor = '#fff0cc';
    }
  };

  const addFullName = (e: ChangedOptionInfo) => {
    fullNames.current = [...fullNames.current, e.fullName];
    changeHightlight(fullNames.current);
  };

  const removeFullName = (e: ChangedOptionInfo) => {
    fullNames.current = fullNames.current.filter((x) => x !== e.fullName);
    changeHightlight(fullNames.current);
  };

  return useCallback(
    (e: ChangedOptionInfo) => {
      switch (e.name) {
        case 'filterValue':
        case 'searchPanel': {
          if (e.value) {
            addFullName(e);
          } else {
            removeFullName(e);
          }
          break;
        }

        case 'columns': {
          if (e.value === undefined) {
            fullNames.current = [];
            changeHightlight(fullNames.current);
            return;
          }

          if (e.value === 'include' || e.value === null || e.value === true || e.value === false) {
            removeFullName(e);
          } else {
            addFullName(e);
          }
          break;
        }
      }
    },
    [fullNames.current],
  );
};
